import {getCurrentBrowserType} from "./helper";

export const PdfViewerType = {
    pdfJsIframe: 'pdfJsIframe', // Newest PDF Viewer using PDF.js
    nativeIframe: 'nativeIframe', // Using native browser's PDF Viewer
    onlyDownloadButton: 'onlyDownloadButton', // Final fallback with only a download button
};

export function getPdfViewerType() {
    const {
        isIOS, isSafari, isMobile, isHuawei, isDuckDuckGo,
        isFirefox, isOpera, isSamsungBrowser, version,
    } = getCurrentBrowserType();

    // Edit here to switch Pdf Viewer Type for different browsers
    if (isIOS && isSafari)
        return PdfViewerType.onlyDownloadButton;
    if (isMobile) {
        // if (isOppoPhone){
        //     return PdfViewerType.onlyDownloadButton
        // }
        if (isHuawei || isDuckDuckGo || isFirefox || isSamsungBrowser)
            return PdfViewerType.pdfJsIframe;
        if (isOpera && parseInt(version, 10) < 50)
            return PdfViewerType.onlyDownloadButton;
    }
    return PdfViewerType.pdfJsIframe;
}
